var Theme = {
  primary: '#2794d8',
  dark: '#2C3E50',
  // Some colours ported from flight-common.  I'm not sure that we still want
  // these colours and I'm certain that they could be better named.
  primaryDark: '#3C637C',
  // $c-primary-color--dark
  textMutedColour: '#6C8579',
  red: '#d8274d',
  pink: '#d82794',
  blue: '#2794d8',
  green: '#27d847',
  green2: '#94d827',
  purple: '#8e27d8',
  yellow: '#d8d527',
  orange: '#d86b27',
  cyan: '#27d8d5'
};
export default Theme;